import * as React from 'react';
import equal from 'fast-deep-equal/react';
import styles from './ContainerPityTimer.scss';
import { DivTooltip } from '@wg/wows-react-uikit';
import { interpolate, t } from '~/utils/localization';
import DefaultTooltip from '~/components/Tooltip/DefaultTooltip';
import { getTextAboutSavePointForTooltip } from '~/Layouts/Lootboxes/utils/texts';
import { useDispatch, useSelector } from 'react-redux';
import { isMobileOrTabletDeviceByAgent } from '~/utils/agent';
import { IChangeVisiblePopup } from '~/Actions/ActionAppType';
import { changeVisiblePopup } from '~/Actions/ActionApp';
import { POPUPS_NAME } from '~/components/PopupManager';
import Info, { InfoSize } from '~/components/Info/Info';
import { State } from '~/Reducers';

interface IContainerPityTimer {
    containerId: number;
    bundleName: string;
    lootbox: ILootboxStateItem;
}

interface IStateSelector {
    lootboxes: StorageInventory;
    lootboxes_without_dropped_rewards: StorageInventory;
}

const stateSelector = (state: State): IStateSelector => {
    return {
        lootboxes: state.ReducerAccount.inventory?.lootboxes,
        lootboxes_without_dropped_rewards: state.ReducerAccount.inventory?.lootboxes_without_dropped_rewards,
    };
};

const ContainerPityTimer = ({ lootbox }: IContainerPityTimer) => {
    const state = useSelector<State, IStateSelector>(stateSelector, equal);
    const dispatch = useDispatch();
    const { savePoint, savePointForValuableGroup } = lootbox;
    const descriptionText = getTextAboutSavePointForTooltip(lootbox);
    const pityTimer = savePoint || savePointForValuableGroup?.savePoint;
    let amountToReward = pityTimer;

    const tooltipBody = [descriptionText];

    if (state.lootboxes && state.lootboxes_without_dropped_rewards) {
        const amountObtained = state.lootboxes[lootbox.id] || 0;
        const amountOpened = (state.lootboxes_without_dropped_rewards[lootbox.id] || 0) % pityTimer;
        amountToReward -= amountOpened;

        tooltipBody.push(
            interpolate(t('Открыто контейнеров: {amount}'), { amount: amountOpened.toString() }),
            interpolate(t('В наличии в Порту: {amount}'), { amount: amountObtained.toString() }),
            t('Информация о количестве может обновляться с задержкой'),
        );
    }

    const text = t('Гарантированное выпадение: {number}').replace('{number}', amountToReward.toString());

    return (
        <DivTooltip
            className={styles.wrapper}
            onClick={() => {
                if (!isMobileOrTabletDeviceByAgent()) {
                    return;
                }
                dispatch<IChangeVisiblePopup>(
                    changeVisiblePopup(POPUPS_NAME.MOBILE_TOOLTIP_POPUP, true, {
                        contents: tooltipBody,
                    }),
                );
            }}
            tooltipBody={<DefaultTooltip text={tooltipBody} />}
        >
            {text}
            <Info size={InfoSize.SMALL} className={styles.label} />
        </DivTooltip>
    );
};

export default ContainerPityTimer;
